/** Kleine, ronde vlagiconen voor de taalknop — vervangt de "NL"/"EN"-tekst zodat de
 * taalkeuze in één oogopslag herkenbaar is, net als bij vergelijkbare boekingswidgets. */

export function FlagNL({ size = 18 }: { size?: number }) {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" aria-hidden="true" style={{ display: "block" }}>
            <clipPath id="bk-flag-nl-circle">
                <circle cx="10" cy="10" r="10" />
            </clipPath>
            <g clipPath="url(#bk-flag-nl-circle)">
                <rect width="20" height="20" fill="#21468B" />
                <rect width="20" height="13.34" fill="#FFFFFF" />
                <rect width="20" height="6.67" fill="#AE1C28" />
            </g>
        </svg>
    );
}

export function FlagGB({ size = 18 }: { size?: number }) {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" aria-hidden="true" style={{ display: "block" }}>
            <clipPath id="bk-flag-gb-circle">
                <circle cx="10" cy="10" r="10" />
            </clipPath>
            <g clipPath="url(#bk-flag-gb-circle)">
                <rect width="20" height="20" fill="#00247D" />
                <path d="M0,0 L20,20 M20,0 L0,20" stroke="#FFFFFF" strokeWidth="4" />
                <path d="M0,0 L20,20 M20,0 L0,20" stroke="#CF142B" strokeWidth="2" />
                <path d="M10,0 V20 M0,10 H20" stroke="#FFFFFF" strokeWidth="6" />
                <path d="M10,0 V20 M0,10 H20" stroke="#CF142B" strokeWidth="3.5" />
            </g>
        </svg>
    );
}
